import { LineChart } from '@mantine/charts';
import { data } from './QualityPerformance.data';
import { Wrapper } from './QualityPerformance.style';

export type QualityPerformanceProps = {};

export function QualityPerformance(_props: QualityPerformanceProps) {
  return (
    <Wrapper className='QualityPerformance-wrapper' data-testid='QualityPerformance-wrapper'>
      <LineChart
        h={300}
        data={data}
        dataKey='date'
        series={[
          { name: 'NOG', color: 'indigo.6' },
          { name: 'Textaco', color: 'blue.6' },
          { name: 'Soda', color: 'teal.6' },
          { name: 'Trellis', color: 'yellow.6' },
        ]}
        yAxisProps={{
          domain: [0, 1],
          tickFormatter: (value) => `${(value * 100).toFixed(0)}%`,
        }}
        curveType='linear'
      />
    </Wrapper>
  );
}

export default QualityPerformance;
